enum NewsType {
  News,
  Event,
  Upcoming,
}

export default NewsType;
